// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const DI: IClientSubSystemModel = {
  Code: 'DI',
  DisplayLabel: 'Diarium',
  BusinessModels: {
    DIDiarieplan: {
      CollectionName: 'DIDiarieplan',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13004']]),
      RootType: {
        TypeValue: 'Diarieplan',
        Abstract: false,
        SOLabel: 'Diarieplan',
        SOGLabel: 'Diarieplan',
        SBLabel: 'Diarieplanen',
        SBGLabel: 'Diarieplanen',
        POLabel: 'Diarieplaner',
        POGLabel: 'Diarieplaner',
        PBLabel: 'Diarieplanerna',
        PBGLabel: 'Diarieplanerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Diarieplanen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Diarieplanen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Diarieplantyp',
          DataType: 'Enum',
          EnumValues: new Map([['DIARIEPLAN', 'Diarieplan']]),
          EnumSortValues: new Map([['DIARIEPLAN', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Diarieplanen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Diarieplanen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEPLANNR: {
          AttributeName: 'DIARIEPLANNR',
          DisplayLabel: 'Kod',
          Hint: 'Alfanumerisk kod / del i diarieplan t.ex. 500',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          Hint: 'Benämning på del av diarieplan t.ex. ansökningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        DIARIENRSERIE_ID: {
          AttributeName: 'DIARIENRSERIE_ID',
          DisplayLabel: 'Diarienr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AdressID: {
          AttributeName: 'AdressID',
          DisplayLabel: 'Mottagare/Avsändare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvsMotNamn: {
          AttributeName: 'AvsMotNamn',
          DisplayLabel: 'Avsändare/Mottagare',
          Hint: 'Organisationens namn eller efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DiarieplanB: {
          AttributeName: 'DiarieplanB',
          DisplayLabel: 'Diarieplan sammansatt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="1";DefDay="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILL_DATUM: {
          AttributeName: 'TILL_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="12";DefDay="31"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Adress: {
          AssociationName: 'Adress',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
      },
    },
    DITEDDIDiarieplannr: {
      CollectionName: 'DITEDDIDiarieplannr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Diarieplannr',
        Abstract: false,
        SOLabel: 'Diarieplannummer',
        SOGLabel: 'Diarieplannummer',
        SBLabel: 'Diarieplannumret',
        SBGLabel: 'Diarieplannumret',
        POLabel: 'Diarieplannummer',
        POGLabel: 'Diarieplannummer',
        PBLabel: 'Diarieplannumren',
        PBGLabel: 'Diarieplannumren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Diarieplannumret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Diarieplannumret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Diarieplannumret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LENGTHVALUE: {
          AttributeName: 'LENGTHVALUE',
          DisplayLabel: 'Length Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MINVALUE: {
          AttributeName: 'MINVALUE',
          DisplayLabel: 'Min Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAXVALUE: {
          AttributeName: 'MAXVALUE',
          DisplayLabel: 'Max Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NEXTVALUE: {
          AttributeName: 'NEXTVALUE',
          DisplayLabel: 'Next Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Last',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfArStr: {
          AttributeName: 'BokfArStr',
          DisplayLabel: 'Bokföringsår',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DIDokumentBlob: {
      CollectionName: 'DIDokumentBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DokumentBlob',
        Abstract: false,
        SOLabel: 'Dokument data',
        SOGLabel: 'Dokuments data',
        SBLabel: 'Dokumentet data',
        SBGLabel: 'Dokumentets data',
        POLabel: 'Dokument data',
        POGLabel: 'Dokuments data',
        PBLabel: 'Dokumenten data',
        PBGLabel: 'Dokumentens data',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets data primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets data versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentets data id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets data fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          Hint: 'Utförlig beskrivning av postförsändelsen.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DIDokument: {
      CollectionName: 'DIDokument',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13008']]),
      RootType: {
        TypeValue: 'DokumentMapp',
        Abstract: true,
        SOLabel: 'Dokument/mapp',
        SOGLabel: 'Dokument/mapp',
        SBLabel: 'Dokumentet/mappen',
        SBGLabel: 'Dokumentet/mappen',
        POLabel: 'Dokument/mappar',
        POGLabel: 'Dokument/mappar',
        PBLabel: 'Dokumenten/mapparna',
        PBGLabel: 'Dokumenten/mapparna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Dokument',
            Abstract: false,
            SOLabel: 'Dokument',
            SOGLabel: 'Dokument',
            SBLabel: 'Dokumentet',
            SBGLabel: 'Dokumentet',
            POLabel: 'Dokument',
            POGLabel: 'Dokument',
            PBLabel: 'Dokumenten',
            PBGLabel: 'Dokumenten',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Dokumentmappen',
            Abstract: false,
            SOLabel: 'Dokumentmapp',
            SOGLabel: 'Dokumentmapp',
            SBLabel: 'Dokumentmappen',
            SBGLabel: 'Dokumentmappen',
            POLabel: 'Dokumentmappar',
            POGLabel: 'Dokumentmappar',
            PBLabel: 'Dokumentmapparna',
            PBGLabel: 'Dokumentmapparna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet/mappen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet/mappen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['DOKUMENT', 'Dokument'], ['DOKUMENTMAPPEN', 'Dokumentmapp']]),
          EnumSortValues: new Map([['DOKUMENT', 'D'], ['DOKUMENTMAPPEN', 'M']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet/mappen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet/mappen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        A_KONTAKT: {
          AttributeName: 'A_KONTAKT',
          DisplayLabel: 'Avsändare kontakt',
          Hint: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AANTECKNING: {
          AttributeName: 'AANTECKNING',
          DisplayLabel: 'Avsändare anteckning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AkontaktID: {
          AttributeName: 'AkontaktID',
          DisplayLabel: 'Extern avsandarkontakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANKOMST: {
          AttributeName: 'ANKOMST',
          DisplayLabel: 'Ankommet/Avsänt datum',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+1m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ARKIVPLATS: {
          AttributeName: 'ARKIVPLATS',
          DisplayLabel: 'Arkivplats',
          Hint: 'Arkivplats t.ex. \'Protokollspärmen\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AvsandareNamn: {
          AttributeName: 'AvsandareNamn',
          DisplayLabel: 'Avsändarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AVSANDARID: {
          AttributeName: 'AVSANDARID',
          DisplayLabel: 'Avsändare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSANDARTYP: {
          AttributeName: 'AVSANDARTYP',
          DisplayLabel: 'Avsändartyp',
          Hint: 'Anteckning',
          DataType: 'Enum',
          EnumValues: new Map([['ANTECKNING', 'Anteckning']]),
          EnumSortValues: new Map([['ANTECKNING', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANTECKNING=Anteckning"',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Rubrik',
          Hint: 'Kort beskrivning av dokumentet.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESLUTSDATUM: {
          AttributeName: 'BESLUTSDATUM',
          DisplayLabel: 'Beslutsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+30d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BESLUTTEXT: {
          AttributeName: 'BESLUTTEXT',
          DisplayLabel: 'Beslut',
          Hint: 'Beskrivande text t.ex paragraf, instans och beslut.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BLOBID: {
          AttributeName: 'BLOBID',
          DisplayLabel: 'Kopplad fil',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dokument'],
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Diarienr2: {
          AttributeName: 'Diarienr2',
          DisplayLabel: 'Ärendenummer',
          Hint: 'Samtliga ärenden där objektet finns.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Yes;']]),
        },
        DIARIEPLANID: {
          AttributeName: 'DIARIEPLANID',
          DisplayLabel: 'DiarieplanID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Dokumenttyp: {
          AttributeName: 'Dokumenttyp',
          DisplayLabel: 'Dokumenttyp',
          Hint: 'Dokument/Dokumentmapp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fildatum: {
          AttributeName: 'Fildatum',
          DisplayLabel: 'Fildatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.notgreater, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Dokument'],
        },
        Filnamn: {
          AttributeName: 'Filnamn',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Dokument'],
        },
        HANDLINGSTYP: {
          AttributeName: 'HANDLINGSTYP',
          DisplayLabel: 'Handlingstypen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INKOMMANDE: {
          AttributeName: 'INKOMMANDE',
          DisplayLabel: 'Inkommande/Utgående',
          Hint: 'Inkommande/Utgående - Inkommen/Upprättad/Utgående',
          DataType: 'Enum',
          EnumValues: new Map([['INKOMMEN', 'Inkommen'], ['UPPRATTAD', 'Upprättad'], ['UTGAENDE', 'Utgående']]),
          EnumSortValues: new Map([['INKOMMEN', 'Y'], ['UPPRATTAD', 'U'], ['UTGAENDE', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INKOMMEN=Inkommen;UPPRATTAD=Upprättad;UTGAENDE=Utgående"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        M_KONTAKT: {
          AttributeName: 'M_KONTAKT',
          DisplayLabel: 'Mottagare Kontakt',
          Hint: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MANTECKNING: {
          AttributeName: 'MANTECKNING',
          DisplayLabel: 'Mottagare anteckning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAPPID: {
          AttributeName: 'MAPPID',
          DisplayLabel: 'Mapp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MkontaktID: {
          AttributeName: 'MkontaktID',
          DisplayLabel: 'Extern mottagarkontakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MottagareNamn: {
          AttributeName: 'MottagareNamn',
          DisplayLabel: 'Mottagarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTTAGARID: {
          AttributeName: 'MOTTAGARID',
          DisplayLabel: 'Mottagare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGARTYP: {
          AttributeName: 'MOTTAGARTYP',
          DisplayLabel: 'Mottagartyp',
          Hint: 'Anteckning',
          DataType: 'Enum',
          EnumValues: new Map([['ANTECKNING', 'Anteckning']]),
          EnumSortValues: new Map([['ANTECKNING', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANTECKNING=Anteckning"',
        },
        PostlisteNR: {
          AttributeName: 'PostlisteNR',
          DisplayLabel: 'Diarienummer',
          Hint: 'Samtliga postförsändelser där objektet finns.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Yes;']]),
        },
        SEKRETESS: {
          AttributeName: 'SEKRETESS',
          DisplayLabel: 'Sekretess',
          Hint: 'Ingen/Skyddad',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN', 'Ingen'], ['SKYDDAD', 'Skyddad']]),
          EnumSortValues: new Map([['INGEN', '0'], ['SKYDDAD', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN=Ingen;SKYDDAD=Skyddad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        MottagareAdress: {
          AttributeName: 'MottagareAdress',
          DisplayLabel: 'Mottagare adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AvsandareAdress: {
          AttributeName: 'AvsandareAdress',
          DisplayLabel: 'Avsändare adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Anteckning: {
          AttributeName: 'Anteckning',
          DisplayLabel: 'Anteckning',
          Hint: 'Anteckning på dokument',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEVAKNINGSDATUM: {
          AttributeName: 'BEVAKNINGSDATUM',
          DisplayLabel: 'Bevakningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinRecommendedDate="-1d";MaxRecommendedDate="+12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Lopnr1: {
          AttributeName: 'Lopnr1',
          DisplayLabel: 'Lopnr1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Lopnr2: {
          AttributeName: 'Lopnr2',
          DisplayLabel: 'Lopnr2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Lopnr3: {
          AttributeName: 'Lopnr3',
          DisplayLabel: 'Lopnr3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Lopnr4: {
          AttributeName: 'Lopnr4',
          DisplayLabel: 'Lopnr4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Lopnr5: {
          AttributeName: 'Lopnr5',
          DisplayLabel: 'Lopnr5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Filnamn2: {
          AttributeName: 'Filnamn2',
          DisplayLabel: 'Filnamn 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Dokument'],
        },
        Filnamn3: {
          AttributeName: 'Filnamn3',
          DisplayLabel: 'Filnamn 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Dokument'],
        },
        Filnamn4: {
          AttributeName: 'Filnamn4',
          DisplayLabel: 'Filnamn 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Dokument'],
        },
        Filnamn5: {
          AttributeName: 'Filnamn5',
          DisplayLabel: 'Filnamn 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Dokument'],
        },
        MaxLopnr: {
          AttributeName: 'MaxLopnr',
          DisplayLabel: 'Största löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handling: {
          AssociationName: 'Handling',
          DisplayLabel: 'Handling på ärende',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIHandling',
          AssociatedComponentName: 'Handling',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Postlista: {
          AssociationName: 'Postlista',
          DisplayLabel: 'Postlista',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIPostlista',
          AssociatedComponentName: 'Postlista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        handTyp: {
          AssociationName: 'handTyp',
          DisplayLabel: 'handlingstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIHandlingstyp',
          AssociatedComponentName: 'Handlingstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avsandare: {
          AssociationName: 'Avsandare',
          DisplayLabel: 'Avsändare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Diarieplan: {
          AssociationName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDiarieplan',
          AssociatedComponentName: 'Diarieplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fil: {
          AssociationName: 'Fil',
          DisplayLabel: 'Fil',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIBlobInfo',
          AssociatedComponentName: 'BlobInfo',
          JoinAssociation: true,
          ValidInComps: ['Dokument'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDokumentBlob',
          AssociatedComponentName: 'DokumentBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fil2: {
          AssociationName: 'Fil2',
          DisplayLabel: 'Fil2',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIBlobInfo',
          AssociatedComponentName: 'BlobInfo',
          JoinAssociation: true,
          ValidInComps: ['Dokument'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fil3: {
          AssociationName: 'Fil3',
          DisplayLabel: 'Fil3',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIBlobInfo',
          AssociatedComponentName: 'BlobInfo',
          JoinAssociation: true,
          ValidInComps: ['Dokument'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fil4: {
          AssociationName: 'Fil4',
          DisplayLabel: 'Fil4',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIBlobInfo',
          AssociatedComponentName: 'BlobInfo',
          JoinAssociation: true,
          ValidInComps: ['Dokument'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fil5: {
          AssociationName: 'Fil5',
          DisplayLabel: 'Fil5',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIBlobInfo',
          AssociatedComponentName: 'BlobInfo',
          JoinAssociation: true,
          ValidInComps: ['Dokument'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDokument',
          AssociatedComponentName: 'Dokument',
          JoinAssociation: false,
          ValidInComps: ['Dokumentmappen'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIBlobInfo: {
      CollectionName: 'DIBlobInfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BlobInfo',
        Abstract: false,
        SOLabel: 'Fil',
        SOGLabel: 'Fil',
        SBLabel: 'Filen',
        SBGLabel: 'Filen',
        POLabel: 'Filer',
        POGLabel: 'Filer',
        PBLabel: 'Filerna',
        PBGLabel: 'Filerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Filen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Filen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['BLOBINFO', 'Fil']]),
          EnumSortValues: new Map([['BLOBINFO', 'I']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Filen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Filen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BSIZE: {
          AttributeName: 'BSIZE',
          DisplayLabel: 'Filstorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        CSIZE: {
          AttributeName: 'CSIZE',
          DisplayLabel: 'Storlek i databas',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        COMPRESSED: {
          AttributeName: 'COMPRESSED',
          DisplayLabel: 'Komprimerad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDTABLENAME: {
          AttributeName: 'IDTABLENAME',
          DisplayLabel: 'Tabellnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORGFILENAME: {
          AttributeName: 'ORGFILENAME',
          DisplayLabel: 'Ursprungligt filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ADATE: {
          AttributeName: 'ADATE',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BLOBID: {
          AttributeName: 'BLOBID',
          DisplayLabel: 'BlobID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORGPATHNAME: {
          AttributeName: 'ORGPATHNAME',
          DisplayLabel: 'Ursprunglig mapp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DIBlob: {
      CollectionName: 'DIBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'BlobFil',
        Abstract: false,
        SOLabel: 'Fil',
        SOGLabel: 'Fil',
        SBLabel: 'Filen',
        SBGLabel: 'Filen',
        POLabel: 'Filer',
        POGLabel: 'Filer',
        PBLabel: 'Filerna',
        PBGLabel: 'Filerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Filen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Filen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['BLOBFIL', 'Fil']]),
          EnumSortValues: new Map([['BLOBFIL', 'F']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Filen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Filen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FILEBLOB: {
          AttributeName: 'FILEBLOB',
          DisplayLabel: 'Sparad fil',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CSIZE: {
          AttributeName: 'CSIZE',
          DisplayLabel: 'Storlek i databas',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DIGruppplan: {
      CollectionName: 'DIGruppplan',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Gruppplan',
        Abstract: false,
        SOLabel: 'Gruppplan',
        SOGLabel: 'Gruppplan',
        SBLabel: 'Gruppplan',
        SBGLabel: 'Gruppplan',
        POLabel: 'Gruppplan',
        POGLabel: 'Gruppplan',
        PBLabel: 'Gruppplan',
        PBGLabel: 'Gruppplan',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gruppplan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gruppplan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['GRUPPPLAN', 'Gruppplan']]),
          EnumSortValues: new Map([['GRUPPPLAN', 'G']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gruppplan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gruppplan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEPLANID: {
          AttributeName: 'DIARIEPLANID',
          DisplayLabel: 'DiarieplanID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Diarieplan: {
          AssociationName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDiarieplan',
          AssociatedComponentName: 'Diarieplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIHandling: {
      CollectionName: 'DIHandling',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Handling',
        Abstract: false,
        SOLabel: 'Handling',
        SOGLabel: 'Handling',
        SBLabel: 'Handlingen',
        SBGLabel: 'Handlingen',
        POLabel: 'Handlingar',
        POGLabel: 'Handlingar',
        PBLabel: 'Handlingarna',
        PBGLabel: 'Handlingarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Handlingen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Handlingen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['HANDLING', 'Handling']]),
          EnumSortValues: new Map([['HANDLING', 'H']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Handlingen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Handlingen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOKUMENTID: {
          AttributeName: 'DOKUMENTID',
          DisplayLabel: 'Dokument ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARENDEID: {
          AttributeName: 'ARENDEID',
          DisplayLabel: 'Ärende ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INSTANSID: {
          AttributeName: 'INSTANSID',
          DisplayLabel: 'Instansens ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATERDATUM: {
          AttributeName: 'ATERDATUM',
          DisplayLabel: 'Återdatum',
          Hint: 'År-månad-dag',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+60m";MinDate="-240m";MaxRecommendedDate="+6m";MinRecommendedDate="-0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        POSTLISTAID: {
          AttributeName: 'POSTLISTAID',
          DisplayLabel: 'PostlistID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          Hint: 'Nummer på handlingen.',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Typbenamning: {
          AttributeName: 'Typbenamning',
          DisplayLabel: 'Handlingstyp',
          Hint: 'Handlingstyp t.ex. \'Protokoll\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue],
          DefaultCondOperator: T.starts,
        },
        Filnamn: {
          AttributeName: 'Filnamn',
          DisplayLabel: 'Filnamn',
          Hint: 'Ursprungligt filnamn t.ex \'M:\\dokument\\tillbyggnad.doc\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PLOPNR: {
          AttributeName: 'PLOPNR',
          DisplayLabel: 'Postlista',
          Hint: 'Nummer i postlistan.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Anteckning: {
          AttributeName: 'Anteckning',
          DisplayLabel: 'Anteckning',
          Hint: 'Anteckning i postlistan',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Postlista: {
          AssociationName: 'Postlista',
          DisplayLabel: 'Postlista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIPostlista',
          AssociatedComponentName: 'Postlista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIDokument',
          AssociatedComponentName: 'Dokument',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Arende: {
          AssociationName: 'Arende',
          DisplayLabel: 'Ärende',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIArende',
          AssociatedComponentName: 'Arende',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIHandlingstyp: {
      CollectionName: 'DIHandlingstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13007']]),
      RootType: {
        TypeValue: 'Handlingstyp',
        Abstract: false,
        SOLabel: 'Handlingstyp',
        SOGLabel: 'Handlingstyp',
        SBLabel: 'Handlingstypen',
        SBGLabel: 'Handlingstypen',
        POLabel: 'Handlingstyper',
        POGLabel: 'Handlingstyper',
        PBLabel: 'Handlingstyperna',
        PBGLabel: 'Handlingstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Handlingstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Handlingstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['HANDLINGSTYP', 'Handlingstyp']]),
          EnumSortValues: new Map([['HANDLINGSTYP', 'H']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Handlingstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Handlingstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          Hint: 'Handlingstypens benämning t.ex. \'Protokoll\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        DEFDIARIEPLAN: {
          AttributeName: 'DEFDIARIEPLAN',
          DisplayLabel: 'Förvald diarieplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEFDIARIEFORS: {
          AttributeName: 'DEFDIARIEFORS',
          DisplayLabel: 'Förvalt diarieförs',
          Hint: 'Skall diarieföras/Skall ej diarieföras',
          DataType: 'Enum',
          EnumValues: new Map([['SKALL_DIARIEFORAS', 'Skall diarieföras'], ['SKALL_EJ_DIARIEFORAS', 'Skall ej diarieföras']]),
          EnumSortValues: new Map([['SKALL_DIARIEFORAS', 'Y'], ['SKALL_EJ_DIARIEFORAS', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKALL_DIARIEFORAS=Skall diarieföras;SKALL_EJ_DIARIEFORAS=Skall ej diarieföras"',
        },
        DEFINKOMMANDE: {
          AttributeName: 'DEFINKOMMANDE',
          DisplayLabel: 'Förvalt inkommande',
          Hint: 'Inkommande/Utgående/Upprättat',
          DataType: 'Enum',
          EnumValues: new Map([['INKOMMANDE', 'Inkommande'], ['UTGAENDE', 'Utgående'], ['UPPRATTAT', 'Upprättat']]),
          EnumSortValues: new Map([['INKOMMANDE', 'Y'], ['UTGAENDE', 'N'], ['UPPRATTAT', 'U']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INKOMMANDE=Inkommande;UTGAENDE=Utgående;UPPRATTAT=Upprättat"',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Diarieplan: {
          AssociationName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIDiarieplan',
          AssociatedComponentName: 'Diarieplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIHandlaggare: {
      CollectionName: 'DIHandlaggare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13005']]),
      RootType: {
        TypeValue: 'Handlaggare',
        Abstract: false,
        SOLabel: 'Handläggare',
        SOGLabel: 'Handläggare',
        SBLabel: 'Handläggaren',
        SBGLabel: 'Handläggaren',
        POLabel: 'Handläggare',
        POGLabel: 'Handläggare',
        PBLabel: 'Handläggarna',
        PBGLabel: 'Handläggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Handläggaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Handläggaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['HANDLAGGARE', 'Handläggare']]),
          EnumSortValues: new Map([['HANDLAGGARE', 'H']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Handläggaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Handläggaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORK: {
          AttributeName: 'FORK',
          DisplayLabel: 'Signatur',
          Hint: 'Handläggarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          Hint: 'Efternamn, förnamn.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        benFork: {
          AttributeName: 'benFork',
          DisplayLabel: 'Förkortning',
          Hint: 'Signatur - Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EPOST: {
          AttributeName: 'EPOST',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GDPRReferensdatum: {
          AttributeName: 'GDPRReferensdatum',
          DisplayLabel: 'Referensdatum GDPR',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
        },
        REGDATUM: {
          AttributeName: 'REGDATUM',
          DisplayLabel: 'Registrerad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Person: {
          AssociationName: 'Person',
          DisplayLabel: 'Person',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Person2: {
          AssociationName: 'Person2',
          DisplayLabel: 'Person 2',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIAvsMot: {
      CollectionName: 'DIAvsMot',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13006']]),
      RootType: {
        TypeValue: 'Adress',
        Abstract: false,
        SOLabel: 'Mottagare/Avsändare',
        SOGLabel: 'Mottagare/Avsändare',
        SBLabel: 'Mottagaren/Avsändaren',
        SBGLabel: 'Mottagaren/Avsändaren',
        POLabel: 'Mottagare/Avsändare',
        POGLabel: 'Mottagare/Avsändare',
        PBLabel: 'Mottagarna/Avsändarna',
        PBGLabel: 'Mottagarna/Avsändarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mottagaren/Avsändaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mottagaren/Avsändaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['ADRESS', 'Mottagare/Avsändare']]),
          EnumSortValues: new Map([['ADRESS', 'M']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Mottagaren/Avsändaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mottagaren/Avsändaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          Hint: 'Organisationens namn eller efternamn, förnamn.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Organisation/Person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GDPRReferensdatum: {
          AttributeName: 'GDPRReferensdatum',
          DisplayLabel: 'Referensdatum GDPR',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Adress: {
          AssociationName: 'Adress',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    DIPostlista: {
      CollectionName: 'DIPostlista',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13003']]),
      RootType: {
        TypeValue: 'Postlista',
        Abstract: false,
        SOLabel: 'Post',
        SOGLabel: 'Post',
        SBLabel: 'Posten',
        SBGLabel: 'Posten',
        POLabel: 'Poster',
        POGLabel: 'Poster',
        PBLabel: 'Posterna',
        PBGLabel: 'Posterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Posten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Posten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Postlisttyp',
          DataType: 'Enum',
          EnumValues: new Map([['POSTLISTA', 'Post']]),
          EnumSortValues: new Map([['POSTLISTA', 'O']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Posten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Posten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDARID: {
          AttributeName: 'ANVANDARID',
          DisplayLabel: 'Användarens ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDARSIGN: {
          AttributeName: 'ANVANDARSIGN',
          DisplayLabel: 'Användarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval],
          DefaultCondOperator: T.starts,
        },
        ARENDEID: {
          AttributeName: 'ARENDEID',
          DisplayLabel: 'Ärende',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'År',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEFORS: {
          AttributeName: 'DIARIEFORS',
          DisplayLabel: 'Ärenderegistreras',
          Hint: 'Skall ärenderegistreras/Skall ej ärenderegistreras',
          DataType: 'Enum',
          EnumValues: new Map([['SKALL_ARENDEREGISTRERAS', 'Skall ärenderegistreras'], ['SKALL_EJ_ARENDEREGISTRERAS', 'Skall ej ärenderegistreras']]),
          EnumSortValues: new Map([['SKALL_ARENDEREGISTRERAS', 'Y'], ['SKALL_EJ_ARENDEREGISTRERAS', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKALL_ARENDEREGISTRERAS=Skall ärenderegistreras;SKALL_EJ_ARENDEREGISTRERAS=Skall ej ärenderegistreras"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        DIARIEFORT: {
          AttributeName: 'DIARIEFORT',
          DisplayLabel: 'Ärenderegistrerat',
          Hint: 'Ärendregistrerat/Ej ärenderegistrerat - Ärenderegistrerat/Ej ärenderegistrerat',
          DataType: 'Enum',
          EnumValues: new Map([['ARENDEREGISTRERAT', 'Ärenderegistrerat'], ['EJ_ARENDEREGISTRERAT', 'Ej ärenderegistrerat']]),
          EnumSortValues: new Map([['ARENDEREGISTRERAT', 'Y'], ['EJ_ARENDEREGISTRERAT', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARENDEREGISTRERAT=Ärenderegistrerat;EJ_ARENDEREGISTRERAT=Ej ärenderegistrerat"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOKUMENTID: {
          AttributeName: 'DOKUMENTID',
          DisplayLabel: 'DokumentID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLOPNR: {
          AttributeName: 'PLOPNR',
          DisplayLabel: 'Löpnummer',
          Hint: 'Löpnummer i postlistan.',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        REGDATUM: {
          AttributeName: 'REGDATUM',
          DisplayLabel: 'Registreringsdatum',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d";MinDate="-0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Anteckning: {
          AttributeName: 'Anteckning',
          DisplayLabel: 'Anteckning',
          Hint: 'Anteckning i postlistan',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        arendenr: {
          AttributeName: 'arendenr',
          DisplayLabel: 'Ärendenummer',
          Hint: 'Diariegrupp-år-löpnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.equals,
        },
        Diarieplan: {
          AttributeName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          Hint: 'Kod plus benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval],
          DefaultCondOperator: T.contains,
        },
        Filnamn: {
          AttributeName: 'Filnamn',
          DisplayLabel: 'Filnamn',
          Hint: 'Ursprungligt filnamn t.ex \'M:\\dokument\\tillbyggnad.doc\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PLOPNR2: {
          AttributeName: 'PLOPNR2',
          DisplayLabel: 'Fullständigt diarienummer',
          Hint: 'Fullständigt diarienummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals],
          DefaultCondOperator: T.starts,
        },
        typbenamning: {
          AttributeName: 'typbenamning',
          DisplayLabel: 'Handlingstypens benämning',
          Hint: 'T.ex. \'Protokoll\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.hasvalue],
          DefaultCondOperator: T.starts,
        },
        Diarieplankod: {
          AttributeName: 'Diarieplankod',
          DisplayLabel: 'Diarieplan kod',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DiarieplanBen: {
          AttributeName: 'DiarieplanBen',
          DisplayLabel: 'Diarieplan benämning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AHandnamn1: {
          AttributeName: 'AHandnamn1',
          DisplayLabel: 'Handläggare ett',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AHandnamn2: {
          AttributeName: 'AHandnamn2',
          DisplayLabel: 'Handläggare två',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Sekretess: {
          AttributeName: 'Sekretess',
          DisplayLabel: 'Sekretess',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIDokument',
          AssociatedComponentName: 'Dokument',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Arende: {
          AssociationName: 'Arende',
          DisplayLabel: 'Ärende',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIArende',
          AssociatedComponentName: 'Arende',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arende2: {
          AssociationName: 'Arende2',
          DisplayLabel: 'Ärende2',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIArende',
          AssociatedComponentName: 'Arende',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Postlistegrupp: {
          AssociationName: 'Postlistegrupp',
          DisplayLabel: 'Postlistegrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSDiariegrupp',
          AssociatedComponentName: 'DiarieGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'KOD,BENAMNING;'], ['OverrideDisplayLabels', 'KOD="Diariegrupp, kod",BENAMNING="Diariegrupp, benämning"']]),
        },
      },
    },
    DIPostlistaBlob: {
      CollectionName: 'DIPostlistaBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PostlistaBlob',
        Abstract: false,
        SOLabel: 'Postlista data',
        SOGLabel: 'Postlistas data',
        SBLabel: 'Postlistan data',
        SBGLabel: 'Postlistans data',
        POLabel: 'Postlistor data',
        POGLabel: 'Postlistors data',
        PBLabel: 'Postlistorna data',
        PBGLabel: 'Postlistornas data',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Postlistans data primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Postlistans data versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Postlistans data id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Postlistans data fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          Hint: 'Utförlig beskrivning av postförsändelsen.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DITEDDIPostlisteNr: {
      CollectionName: 'DITEDDIPostlisteNr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Postlistnr',
        Abstract: false,
        SOLabel: 'Postlista nummerserie',
        SOGLabel: 'Postlistas nummerserie',
        SBLabel: 'Postlistan nummerserie',
        SBGLabel: 'Postlistans nummerserie',
        POLabel: 'Postlista nummerserier',
        POGLabel: 'Postlista nummerseriers',
        PBLabel: 'Postlistan nummerserier',
        PBGLabel: 'Postlistan nummerseriers',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Postlistans nummerserie primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Postlistans nummerserie versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Postlistans nummerserie id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LENGTHVALUE: {
          AttributeName: 'LENGTHVALUE',
          DisplayLabel: 'Length Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MINVALUE: {
          AttributeName: 'MINVALUE',
          DisplayLabel: 'Min Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAXVALUE: {
          AttributeName: 'MAXVALUE',
          DisplayLabel: 'Max Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NEXTVALUE: {
          AttributeName: 'NEXTVALUE',
          DisplayLabel: 'Next Value',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Last',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfArStr: {
          AttributeName: 'BokfArStr',
          DisplayLabel: 'Bokföringsår',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    DIArende: {
      CollectionName: 'DIArende',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '13001'], ['EmailPaths', 'Handläggare1=Handlaggare.person.adress.smtp1'], ['Handläggare2', 'Handlaggare2.person.adress.smtp1']]),
      RootType: {
        TypeValue: 'Arende',
        Abstract: false,
        SOLabel: 'Ärende',
        SOGLabel: 'Ärende',
        SBLabel: 'Ärendet',
        SBGLabel: 'Ärendet',
        POLabel: 'Ärenden',
        POGLabel: 'Ärenden',
        PBLabel: 'Ärendena',
        PBGLabel: 'Ärendena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ärendet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ärendet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Ärendetyp',
          DataType: 'Enum',
          EnumValues: new Map([['ARENDE', 'Ärende']]),
          EnumSortValues: new Map([['ARENDE', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ärendet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ärendet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REGDATUM: {
          AttributeName: 'REGDATUM',
          DisplayLabel: 'Registreringsdatum',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d";MinDate="-0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          Hint: 'Kortfattad beskrivning.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        SEKRETESSGRUPP: {
          AttributeName: 'SEKRETESSGRUPP',
          DisplayLabel: 'Sekretessgrupp',
          Hint: 'Ingen/Skyddad',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN', 'Ingen'], ['SKYDDAD', 'Skyddad']]),
          EnumSortValues: new Map([['INGEN', '0'], ['SKYDDAD', '2']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN=Ingen;SKYDDAD=Skyddad"',
        },
        DIARIENR: {
          AttributeName: 'DIARIENR',
          DisplayLabel: 'Löpnummer',
          Hint: 'Ärendets löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000000000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DIARIEPLANID: {
          AttributeName: 'DIARIEPLANID',
          DisplayLabel: 'DiarieplanID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDLAGGARID: {
          AttributeName: 'HANDLAGGARID',
          DisplayLabel: 'Handläggare ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEVAKNING: {
          AttributeName: 'BEVAKNING',
          DisplayLabel: 'Bevakning',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinRecommendedDate="-6m";MaxRecommendedDate="+12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MOTTAGET: {
          AttributeName: 'MOTTAGET',
          DisplayLabel: 'Mottaget ärende',
          Hint: 'Inkommande/Upprättat - Inkommande/Upprättat/Utgående',
          DataType: 'Enum',
          EnumValues: new Map([['INKOMMANDE', 'Inkommande'], ['UPPRATTAT', 'Upprättat'], ['UTGAENDE', 'Utgående']]),
          EnumSortValues: new Map([['INKOMMANDE', 'Y'], ['UPPRATTAT', 'N'], ['UTGAENDE', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INKOMMANDE=Inkommande;UPPRATTAT=Upprättat;UTGAENDE=Utgående"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        AVSLUT: {
          AttributeName: 'AVSLUT',
          DisplayLabel: 'Avslut',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+6m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        POSTLISTAID: {
          AttributeName: 'POSTLISTAID',
          DisplayLabel: 'PostlistId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INITDATUM: {
          AttributeName: 'INITDATUM',
          DisplayLabel: 'Ärendedatum',
          Hint: 'År-månad-dag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+1m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KNYTID: {
          AttributeName: 'KNYTID',
          DisplayLabel: 'Knutna ärenden',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIARIEGRUPPID: {
          AttributeName: 'DIARIEGRUPPID',
          DisplayLabel: 'Diariegrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDLAGGARID2: {
          AttributeName: 'HANDLAGGARID2',
          DisplayLabel: 'Handläggare 2 ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'År',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Handnamn: {
          AttributeName: 'Handnamn',
          DisplayLabel: 'Handläggarens namn',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Diarienr2: {
          AttributeName: 'Diarienr2',
          DisplayLabel: 'Ärendenummer',
          Hint: 'Diariegrupp-år-löpnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals],
          DefaultCondOperator: T.starts,
        },
        Handnamn2: {
          AttributeName: 'Handnamn2',
          DisplayLabel: 'Handläggare sekundär',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Knuten: {
          AttributeName: 'Knuten',
          DisplayLabel: 'Knutet ärende',
          Hint: 'Knuten/Ej knuten',
          DataType: 'Enum',
          EnumValues: new Map([['KNUTEN', 'Knuten'], ['EJ_KNUTEN', 'Ej knuten']]),
          EnumSortValues: new Map([['KNUTEN', 'Y'], ['EJ_KNUTEN', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KNUTEN=Knuten;EJ_KNUTEN=Ej knuten"',
          InterfaceType: 'ifBoolean',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          Hint: 'Anteckningsfält',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REGAR: {
          AttributeName: 'REGAR',
          DisplayLabel: 'Registreringsår',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.equals,
        },
        Diarieplan: {
          AttributeName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue],
          DefaultCondOperator: T.starts,
        },
        hBevakning: {
          AttributeName: 'hBevakning',
          DisplayLabel: 'Handling med bevakning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        hSekretess: {
          AttributeName: 'hSekretess',
          DisplayLabel: 'Handling med sekretess',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Diarieplankod: {
          AttributeName: 'Diarieplankod',
          DisplayLabel: 'Diarieplan kod',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DiarieplanBen: {
          AttributeName: 'DiarieplanBen',
          DisplayLabel: 'Diarieplan benämning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ARKIVPLATS: {
          AttributeName: 'ARKIVPLATS',
          DisplayLabel: 'Arkivplats',
          Hint: 'Arkivplats t.ex. \'Protokollspärmen\'',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        ANVANDARSIGN: {
          AttributeName: 'ANVANDARSIGN',
          DisplayLabel: 'Användarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIArendeBlob',
          AssociatedComponentName: 'ArendeBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Diarieplan: {
          AssociationName: 'Diarieplan',
          DisplayLabel: 'Diarieplan',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDiarieplan',
          AssociatedComponentName: 'Diarieplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handlaggare: {
          AssociationName: 'Handlaggare',
          DisplayLabel: 'Handläggare',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIHandlaggare',
          AssociatedComponentName: 'Handlaggare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Postlista: {
          AssociationName: 'Postlista',
          DisplayLabel: 'Registrerad från postlistan',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIPostlista',
          AssociatedComponentName: 'Postlista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Diariegrupp: {
          AssociationName: 'Diariegrupp',
          DisplayLabel: 'Diariegrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSDiariegrupp',
          AssociatedComponentName: 'DiarieGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'KOD,BENAMNING;'], ['OverrideDisplayLabels', 'KOD="Diariegrupp, kod",BENAMNING="Diariegrupp, benämning"']]),
        },
        Handlaggare2: {
          AssociationName: 'Handlaggare2',
          DisplayLabel: 'Handläggare sekundär',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIHandlaggare',
          AssociatedComponentName: 'Handlaggare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handlingar: {
          AssociationName: 'Handlingar',
          DisplayLabel: 'Handlingar på ärende',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'DIHandling',
          AssociatedComponentName: 'Handling',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Knutna: {
          AssociationName: 'Knutna',
          DisplayLabel: 'Knutna ärenden',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIArende',
          AssociatedComponentName: 'Arende',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    DIArendeBlob: {
      CollectionName: 'DIArendeBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArendeBlob',
        Abstract: false,
        SOLabel: 'Ärendedata',
        SOGLabel: 'Ärendedatas',
        SBLabel: 'Ärendedatat',
        SBGLabel: 'Ärendedatats',
        POLabel: 'Ärendedata',
        POGLabel: 'Ärendedatas',
        PBLabel: 'Ärendedatan',
        PBGLabel: 'Ärendedatans',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ärendedatats primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ärendedatats versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ärendedatats id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ärendedatats fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          Hint: 'Utförligare beskrivning av ärendet - anteckningar.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
  },
};

export default DI;
